"use strict";

var renderTemplate = require('./renderTemplate');

module.exports = function () {
	$('[handlebars-template-container]').each(function () {
		var $this = $(this);

		$this.on('click', '[js-discipline-link]', function (event) {
			event.preventDefault();

			var $this = $(this),
				linkHref = $this.attr('href'),
				apiUrl = $this.data('apiUrl'),
				templateName = $this.data('templateName'),
				scrollTop = $(window).scrollTop(),
				requestParams = {},
				$templateContainer = $('[handlebars-template-container]');

			$.each($this.data(), function (name, value) {
				if (name.indexOf('request_') != -1) {
					requestParams[name.substr(8)] = value;
				}
			});

			if (linkHref.indexOf('real') != -1) {
				requestParams['real'] = true;
			}

			$.ajax(apiUrl, {
				"data" : requestParams,
				"dataType " : "json",
				"success" : function (data) {
					var state = Object.assign({}, window.history.state),
						$dataTable = $(".data-tables").first();

					state["scroll"] = scrollTop;
					if ($dataTable.data("dataTableInitialized")) {
						state["page"] = $dataTable.DataTable().page();
					}

					window.history.replaceState(state, null);
					window.history.pushState({
						"apiUrl" : apiUrl,
						"templateName" : templateName,
						"requestParams" : requestParams
					}, null, linkHref);

					renderTemplate($templateContainer, data, templateName);
					$templateContainer.data('apiUrl', apiUrl);
					$templateContainer.data('templateName', templateName);
				},
				"error": function (data) {
					renderTemplate($templateContainer, data.responseJSON);
				}
			});
		});

		window.onpopstate = function (event) {
			if (event.state && event.state.hasOwnProperty('apiUrl')) {
				renderReportFromHistoryState(event.state);
			} else {
				window.location.reload();
			}
		};

		if (!$this.find('form').length) {
			var apiUrl = $this.data('apiUrl'),
				templateName = $this.data('templateName'),
				requestParams = {};

			if (window.location.search.indexOf('?') != -1) {
				$.each(window.location.search.substring(1).split('&'), function (i, value) {
					var param = value.split('=');
					requestParams[param[0]] = decodeURIComponent(param[1]).replace(/\+/g, ' ');
				});
			}

			renderReport(apiUrl, requestParams, templateName);
		}
	});
};

function renderReport(apiUrl, requestParams, templateName) {
	$.ajax(apiUrl, {
		"data" : requestParams,
		"dataType " : "json",
		"success" : function (data) {
			renderTemplate($('[handlebars-template-container]'), data, templateName);
		},
		"error": function (data) {
			renderTemplate($('[handlebars-template-container]'), data.responseJSON);
		}
	});
}

function renderReportFromHistoryState(state) {
	var $templateContainer = $('[handlebars-template-container]');

	$.ajax(state.apiUrl, {
		"data" : state.requestParams,
		"dataType " : "json",
		"success" : function (data) {
			renderTemplate($templateContainer, data, state.templateName);
			$templateContainer.data('apiUrl', state.apiUrl);
			$templateContainer.data('templateName', state.templateName);

			var $dataTable = $(".data-tables").first();
			if (state.hasOwnProperty('page') && $dataTable.data("dataTableInitialized")) {
				$dataTable.DataTable().page(state.page).draw("page");
			}

			if (state.hasOwnProperty('scroll')) {
				$(window).scrollTop(state.scroll);
			}
		},
		"error": function (data) {
			renderTemplate($templateContainer, data.responseJSON);
		}
	});
}